import { useEffect, useState } from 'react';
import { Typography } from '@axafr-btc-ds/typography';
import { ColorHex } from '@axafr-btc-ds/colors';
import { IfLayout } from '@axa-fr-axion/layouts';
import { GroupInputRadio } from '@axa-fr-axion/input-radio';
import { MessageOphelie } from '@axafr-btc-ds/messages';
import {
    LogementTypeDataInput, LogementTypeOptions,
    LogementTypeProps,
} from './LogementType.interface';
import styles from './LogementType.module.css';
import classNames from 'classnames';

const LOGEMENT_TYPE_LABEL = 'Que souhaitez-vous assurer ?';
const OPHELIE_CONTENT = 'Bonjour et bienvenue chez AXA. Pour permettre à nos conseillers de vous' +
    ' accompagner au mieux dans votre projet d\'assurance habitation, nous avons besoin d\'en savoir plus.';

const OPTIONS: ReadonlyArray<LogementTypeDataInput> = [
    {
        label: 'Un appartement',
        value: 'appartement',
    },
    {
        label: 'Une maison',
        value: 'maison',
    },
    {
        label: 'Un autre bien : mobile-home, manoir...',
        value: 'autre',
    },
];
export const LogementType = ({ onChange, data }: LogementTypeProps): JSX.Element => {
    const [ selectedValue, setSelectedValue ] = useState<string>(data || '');

    useEffect(() => {
        if (!!data?.length) {
            const selectedOption = OPTIONS.find(item => item.value === data);

            if (!!selectedOption) {
                onChange?.(data, 'Valid');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (value?: string) => {
        const newSelectedValue: LogementTypeOptions = value as LogementTypeOptions;
        setSelectedValue(newSelectedValue);

        onChange?.(newSelectedValue, 'Valid');
    };

    return (
        <>
            <MessageOphelie className={ classNames(styles.ophelie) }>
                { OPHELIE_CONTENT }
            </MessageOphelie>
            <Typography
                color={ ColorHex.axablue }
                component='h2'
                variant='title1'
            >
                { LOGEMENT_TYPE_LABEL }
            </Typography>
            <IfLayout className={ styles.layout }>
                <GroupInputRadio
                    layout='stacked'
                    dataInput={ OPTIONS }
                    value={ selectedValue }
                    onChange={ handleChange }
                />
            </IfLayout>
        </>
    );
};

export default LogementType;
